import {ValueObject} from '@s-ui/domain'

import {PriceRangeMetaDataSearchValueObject} from './PriceRangeMetaDataSearchValueObject.js'

export class MetaDataSearchValueObject extends ValueObject {
  #priceRange

  constructor({priceRange}) {
    super()
    this.#priceRange = priceRange
  }

  static create({priceRange}) {
    return new MetaDataSearchValueObject({priceRange: PriceRangeMetaDataSearchValueObject.create(priceRange)})
  }

  static createFromPrimitive({metaData = {}}) {
    return new MetaDataSearchValueObject({
      priceRange: PriceRangeMetaDataSearchValueObject.create({priceRange: metaData.priceRange || {}})
    })
  }

  get priceRange() {
    return this.#priceRange.value
  }

  get value() {
    return {priceRange: this.#priceRange.value}
  }

  toJSON() {
    return {priceRange: this.#priceRange.toJSON()}
  }
}
